(() => {
 if (window.avgarShellReady) return; window.avgarShellReady = true;
 const breakpoint = window.matchMedia('(min-width:750px)');
 function init(){
  document.querySelectorAll('.avgar-footer__links').forEach(d=>{d.open=breakpoint.matches;});
  document.querySelectorAll('.avgar-header details').forEach(d=>{
   if(d.dataset.bound) return; d.dataset.bound='true';
   d.addEventListener('keydown',e=>{if(e.key==='Escape'){d.open=false;d.querySelector('summary').focus();}});
   d.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{d.open=false;}));
  });
 }
 init(); breakpoint.addEventListener('change',init);document.addEventListener('shopify:section:load',init);
})();

// Keep merchant-entered internal links in the shopper's selected language.
(() => {
  const config = document.querySelector('[data-locale-root]');
  if (!config) return;
  const root = config.dataset.localeRoot.replace(/\/$/, '');
  const languages = config.dataset.localeCodes.split(',');
  function localizeLink(link) {
    const href = link.getAttribute('href');
    if (!href || /^(#|mailto:|tel:|javascript:)/i.test(href) || link.hasAttribute('download') || link.hasAttribute('hreflang')) return;
    const url = new URL(href, window.location.href);
    if (url.origin !== window.location.origin) return;
    const parts = url.pathname.split('/');
    if (languages.includes(parts[1])) return;
    if (!/^\/(?:$|products(?:\/|$)|collections(?:\/|$)|pages(?:\/|$)|blogs(?:\/|$)|policies(?:\/|$)|search(?:\/|$)|cart(?:\/|$))/.test(url.pathname)) return;
    if (root) link.setAttribute('href', root + (url.pathname === '/' ? '' : url.pathname) + url.search + url.hash);
  }
  function updateLinks(scope) { scope.querySelectorAll('a[href]').forEach(localizeLink); }
  updateLinks(document);
  document.addEventListener('shopify:section:load', event => updateLinks(event.target));
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link) localizeLink(link);
  }, true);
  document.querySelectorAll('.avgar-localization__form').forEach(form => {
    form.addEventListener('submit', () => {
      const button = form.querySelector('button[type="submit"]');
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
    });
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.avgar-localization__form button').forEach(button => {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
  });
})();
